import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PersonFilled } from "../icons/PersonFilled";
import { BellFilled } from "../icons/BellFilled";
import { AuthService } from "../../services/auth.service";
import { OrganisationService } from "../../services/organisation.service";
import { ProfileService } from "../../services/profile.service";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const user = AuthService.getCurrentUser();
  const userProfile = ProfileService.getUserProfileFromStorage();

  const { data: organisationData } = useQuery({
    queryKey: ["organisation-data"],
    queryFn: async () => {
      const currentUser = AuthService.getCurrentUser();
      if (currentUser?.organisationName) {
        return await OrganisationService.getOrganisation(currentUser.organisationName);
      }
      return null;
    },
    enabled: !!user?.organisationName,
  });

  const handleProfile = () => {
    navigate("/profile");
  };

  return (
    <header className="bg-[#EFF0F2] border-b-2 border-border-gray sticky top-0 z-30 md:relative">
      <div className="mx-auto px-2 sm:px-6 lg:px-6 bg-default-99">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-3">
            {organisationData?.logoUrl && (
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src={organisationData.logoUrl}
                  alt={organisationData.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            )}
            <h1 className="text-xl text-black uppercase font-bold">
              {organisationData?.name ||
                user?.organisationName ||
                userProfile?.organisationName ||
                "CLINICS NAME"}
            </h1>
          </div>
          <div className="flex items-center space-x-4">
            <button className="p-2 bg-primary-blue text-white hover:bg-indigo-darker-blue transition-colors hover:cursor-no-drop">
              <BellFilled className="h-5 w-5" />
            </button>
            <button
              onClick={handleProfile}
              className="p-2 bg-black text-white hover:bg-gray-800 transition-colors"
            >
              <PersonFilled className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
